//styles
require('./amazonGiftCardPromotions.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @commons
const { OKButton } = require('components/commons/OKButton/OKButton');
const { EmptyState } = require('commonsComponents/emptyState');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @components
const AmazonGiftCardPromotionBox = require('components/amazonGiftCardPromotionBox/amazonGiftCardPromotionBox');

// @helpers
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;
const { getPublicSiteUrl } = require('core/apiURLBuilder');

// @constants
const { AMAZON_GIFT_CARD_LOCATION_ID } = require('constants/accountAmazonGiftCard');
const { COUNTRY_CODE_ES } = require('commonsConstants/countryCodes');
const { AMAZON_PROMOCIONES, AMAZON_GIFT_CARD_HIRING_REINTENTAR } = require('constants/tagging');

//@utils
const { recordLinkV2 } = require("utilities/tagging");

class AmazonGiftCardPromotions extends React.Component {

    constructor(props) {
        super(props);
        this.handleRetry = this.handleRetry.bind(this);
    }

    handleRetry(){
        const { getAmazonPromotionCard } = this.props;
        getAmazonPromotionCard(AMAZON_GIFT_CARD_LOCATION_ID);
        const customData = ({
            categoriaEvento: AMAZON_PROMOCIONES,
            accionEvento: AMAZON_GIFT_CARD_HIRING_REINTENTAR
        });
        recordLinkV2(customData);
    }

    handleBackNavigationToPromotions() {
        const publicPromotionsPath = getLanguage().toLowerCase() === COUNTRY_CODE_ES.toLowerCase() ? '/ofertas-bancarias' : '/en/bank-promotions';
        let publicSiteUrl = getPublicSiteUrl();
        if (!!publicSiteUrl && publicSiteUrl.slice(publicSiteUrl.length - 3, -2) === "/") {
            publicSiteUrl = publicSiteUrl.slice(0, -3);
        }
        const publicPromotionsLink = `${publicSiteUrl}${publicPromotionsPath}`;
        window.location.href = publicPromotionsLink;
        const customData = ({
            categoriaEvento: AMAZON_PROMOCIONES,
            accionEvento: "ir a promociones y descuentos"
        });
        recordLinkV2(customData);
    }

    render() {
        const {
            immAmazonGiftCard,
            selectedAccount,
         } = this.props;
        const promotionAd = immAmazonGiftCard.get('promotionAd');
        let content;

        if (immAmazonGiftCard.get('promotionsIsFetching')) {
            content = (<LoadingSection />);
        } else if (immAmazonGiftCard.get('promotionsError')) {
            const retryButton = (
                <OKButton
                    onClick={this.handleRetry}
                    modifier="secondary">
                    <FormattedText value="common-retry" />
                </OKButton>
            );
            content = (
                <div className="amazon-gift-card-promotions__empty-state">
                    <EmptyState
                        primaryText={formatText('amazonGiftCard-promotionErrorState')}
                        secondaryText={formatText('amazonGiftCard-promotionErrorStateDescription')}
                        button={retryButton} 
                        iconType="nointernet-banking"
                    />
                </div>
            );

        } else if (immAmazonGiftCard.get('promotionsSuccess') && promotionAd.size != 0) {
            content = (
                <AmazonGiftCardPromotionBox
                    promotionAd={promotionAd}
                    selectedAccount={selectedAccount}
                />
            );
        } else {
            const button = (
                <OKButton
                    onClick={this.handleBackNavigationToPromotions}
                    modifier="secondary">
                    <FormattedText value="amazonGiftCard-noPromotionsButtonText" />
                </OKButton>
            );
            content = (
                <div className="amazon-gift-card-promotions__empty-state">
                    <EmptyState 
                        primaryText={formatText('amazonGiftCard-noPromotions')} 
                        iconType="search-banking" 
                        button={button}/>
                        
                </div>
            );
        }

        return (
            <div className="amazon-gift-card-promotions">
                {content}
            </div>
        );
    }
}

AmazonGiftCardPromotions.propTypes = {
    selectedAccount: PropTypes.object.isRequired,
    immAmazonGiftCard: PropTypes.object.isRequired,
    getAmazonPromotionCard: PropTypes.func.isRequired,
};

module.exports = AmazonGiftCardPromotions;
